import axios from 'axios';
import { getHeaders } from './utils';
import { AULA_ASSIGNMENTS } from '../../constants/endpoints';

const create = (accessToken, spaceId, assignment, sessionToken) =>
  axios.post(
    `${AULA_ASSIGNMENTS()}`,
    {
      classId: spaceId,
      ...assignment,
    },
    {
      headers: { ...getHeaders(accessToken), 'x-session-token': sessionToken },
    }
  );

export default create;
